/**
 * Browser update checks can reject while a tab is offline, suspended, or a
 * deployment is replacing assets. Keep those expected background failures
 * out of the global unhandled-rejection path.
 */
export async function updateServiceWorkerSafely(
  registration: Pick<ServiceWorkerRegistration, "update">,
): Promise<boolean> {
  try {
    await registration.update();
    return true;
  } catch {
    return false;
  }
}
